import { useState, useEffect } from 'react'
import jwtDecode from 'jwt-decode'
import Button from 'components/forms/Button'
import { webApi } from 'lib/api'
import styles from './styles/ImpersonationBanner.css'
import { getLocalStorage } from '../../lib/get-local-storage'

const ImpersonationBanner = () => {
  const [isImpersonating, setIsImpersonating] = useState(false)
  const [targetEmail, setTargetEmail] = useState('')
  const [isStopping, setIsStopping] = useState(false)

  useEffect(() => {
    const checkImpersonationStatus = () => {
      const localStorage = getLocalStorage()
      try {
        const token = localStorage?.getItem('apiToken')
        if (!token) {
          setIsImpersonating(false)
          return
        }

        const decoded = jwtDecode(token)
        if (decoded.impersonated_by) {
          setIsImpersonating(true)
          setTargetEmail(decoded.email || 'Unknown User')
        } else {
          setIsImpersonating(false)
        }
      } catch (e) {
        console.error('Error checking impersonation status:', e)
        setIsImpersonating(false)
      }
    }
    checkImpersonationStatus()
  }, [])
  const handleStopImpersonation = async () => {
    const localStorage = getLocalStorage()
    try {
      setIsStopping(true)

      await webApi.post('/users/stop-impersonation')

      localStorage.removeItem('apiToken')
      localStorage.removeItem('originalToken')

      window.location.href = '/?login=true'
    } catch (e) {
      console.error('Error stopping impersonation:', e)
      setIsStopping(false)

      localStorage.removeItem('apiToken')
      localStorage.removeItem('originalToken')
      window.location.href = '/?login=true'
    }
  }

  if (!isImpersonating) {
    return null
  }

  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <span className={styles.warning}>⚠️</span>
        <span className={styles.message}>
          You are impersonating <strong>{targetEmail}</strong>
        </span>
        <Button
          onClick={handleStopImpersonation}
          color='red'
          className={styles.button}
          disabled={isStopping}
          title='Stop impersonating and log out'
        >
          {isStopping ? 'Logging out...' : 'Stop & Log Out'}
        </Button>
      </div>
    </div>
  )
}

export default ImpersonationBanner
